import { render, staticRenderFns } from "./ControlDetail.vue?vue&type=template&id=3cb33f6b"
import script from "./ControlDetail.vue?vue&type=script&lang=js"
export * from "./ControlDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports